import './styles.scss';
import Button from '../button';

const Hero = ({
    heading,
    video,
    image,
    bookAccommodationText,
    bookAccommodationButtonText,
    accommodationText,
    bookTicketText,
    bookTicketButtonText,
    boatTypeText,
    lockTicketText,
    dateCtrl,
    checked
}) => {
    return (
        <section className="hero">
            <div className="hero__video" style={(image && !video) ? {
                backgroundImage: `url(${image.src})`
            } : {}}>
                {video && video.src &&
                    <video autoPlay muted loop className="hero__video-player" poster={image && image.src}>
                        <source src={video.src} type="video/mp4" />
                    </video>
                }
            </div>
            <div className="hero__heading">
                {heading}
            </div>

            <div className="hero__search">
                <div className="hero__search-tabs">
                    <input id="book-ticket" type="radio" name="tab" {...checked} />
                    <label htmlFor="book-ticket">
                       {bookTicketText}
                    </label>
                    <div className="hero__search-tab-panel hero__search-tab-panel--lock-ticket">
                        <form className="hero__search-form-lock-ticket">
                            <select>
                                <option>{boatTypeText}</option>
                            </select>
                            <Button type="button" uiType="cta">{bookTicketButtonText}</Button>
                        </form>
                        <div className="hero__search-form-lock-ticket-text">
                            {lockTicketText}
                        </div>
                    </div>
                    <input id="book-accommodation" type="radio" name="tab" />
                    <label htmlFor="book-accommodation">{bookAccommodationText}</label>
                    <div className="hero__search-tab-panel hero__search-tab-panel--lock-ticket">
                        <form className="hero__search-form-accommodation">
                            <div id="date-control">
                                {dateCtrl}
                            </div>
                            <Button type="button" uiType="cta">{bookAccommodationButtonText}</Button>
                        </form>
                        <div className="hero__search-form-lock-ticket-text">
                            {accommodationText}
                        </div>
                    </div>
                </div>
                
            </div>
        </section>
        
    );
};

export default Hero;